export default "__VITE_ASSET__BkiHOHBD__"